import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import { capabilityKeys } from './useCapabilities';

export const syncKeys = {
  status: ['ragnarok-sync', 'status'] as const,
};

export function useSyncStatus(enabled: boolean = true) {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: syncKeys.status,
    queryFn: () => api.getCapabilitySyncStatus(),
    refetchInterval: (query) => {
      // Poll every 5 seconds while sync is in progress
      if (query.state.data?.status === 'IN_PROGRESS') {
        return 5000;
      }
      // Sync just finished — refresh capabilities so new data appears
      if (query.state.data?.status === 'COMPLETED' || query.state.data?.status === 'FAILED') {
        queryClient.invalidateQueries({ queryKey: capabilityKeys.all });
      }
      return false;
    },
    enabled,
  });
}

export function useStartSync() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => api.startCapabilitySync(),
    onSuccess: () => {
      // Start polling by invalidating the status query
      queryClient.invalidateQueries({ queryKey: syncKeys.status });
    },
  });
}
